import { useState } from "react";
import { Link } from "react-router-dom";
import { commentWall } from "@/mocks/comments";
import Reveal from "@/components/base/Reveal";

export default function CommentWall() {
  const [liked, setLiked] = useState<string[]>([]);

  const toggleLike = (id: string) => {
    setLiked((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  return (
    <section id="wall" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <span className="flex items-center gap-2 text-xs tracking-[0.3em] text-primary-500">
              <i className="ri-chat-quote-line" />
              COMMENT WALL
            </span>
            <h2 className="heading-serif mt-3 text-2xl font-black text-foreground-950 md:text-3xl">
              评论区热聊 · 观点正在互相碰撞
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-500">
              这里是全站最鲜活的一部分。同一个话题，能看到完全相反的推理，而且大多讲得有条有理。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 gap-4 md:columns-2 lg:columns-3">
          {commentWall.map((comment, index) => {
            const isLiked = liked.includes(comment.id);
            return (
              <Reveal key={comment.id} delay={index * 40} className="mb-4 break-inside-avoid">
                <article className="rounded-lg border border-background-200/80 bg-background-100 p-5">
                  <header className="flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-sm font-medium text-secondary-900">
                      {comment.user.slice(0, 1)}
                    </span>
                    <div className="min-w-0">
                      <p className="flex items-center gap-2 text-sm font-medium text-foreground-950">
                        {comment.user}
                        <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[10px] font-normal text-accent-500">
                          {comment.level}
                        </span>
                      </p>
                      <p className="mt-0.5 text-xs text-foreground-500">{comment.time}</p>
                    </div>
                  </header>

                  <p className="mt-4 text-sm leading-relaxed text-foreground-700">{comment.content}</p>

                  <Link
                    to={`/topics/${comment.topicId}`}
                    className="mt-4 flex items-center gap-1.5 rounded-md bg-background-200/60 px-3 py-2 text-xs text-foreground-600 transition-colors hover:text-primary-500"
                  >
                    <i className="ri-discuss-line text-primary-400" />
                    来自话题：{comment.topicTitle}
                  </Link>

                  <footer className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                    <button
                      type="button"
                      onClick={() => toggleLike(comment.id)}
                      aria-pressed={isLiked}
                      className={`flex items-center gap-1.5 transition-colors ${
                        isLiked ? "text-primary-500" : "hover:text-primary-500"
                      }`}
                    >
                      <i className={isLiked ? "ri-heart-3-fill" : "ri-heart-3-line"} />
                      {comment.likes + (isLiked ? 1 : 0)}
                    </button>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-chat-3-line" />
                      {comment.replies}
                    </span>
                    <Link
                      to={`/topics/${comment.topicId}`}
                      className="ml-auto flex items-center gap-1 transition-colors hover:text-accent-500"
                    >
                      去回复
                      <i className="ri-arrow-right-line" />
                    </Link>
                  </footer>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}